/*
    Create By Baizhiming 2015-10-16
*/
'use strict';
angular.module("manageCfg.roleManageMent.editorcreateRole.changeGroup", []).controller("changeGroupCtrl", ["$scope", "modalDialog", "trsHttpService", "$state", "$timeout", function($scope, modalDialog, trsHttpService, $state, $timeout) {
    initStatus();
    $scope.theShowToggle = function(node) {
        if (node.HASCHILDREN == "true" && node.CHILDREN.length === 0) {
            var paramsT = {
                "serviceid": "mlf_group",
                "methodname": "queryChildGroupsWithSecondRight",
                "GroupId": node.GROUPID
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paramsT, "get").then(function(dataC) {
                node.CHILDREN = dataC.CHILDREN;
            });
        }
    };
    $scope.cancel = function() {
        $state.go("manageconfig.rolemanage.editorcreaterole");
    };
    $scope.confirm = function() {
        //保存角色服务开始
        var params = {
            "serviceid": "mlf_extrole",
            "methodname": "save",
            "RoleId": $scope.roleData.ROLEID,
            "GroupId": $scope.selectedNodeCopy.GROUPID,
            "RoleName": $scope.roleData.ROLENAME
        };
        //trsHttpService.httpServer("./manageConfig/data/roledata_" + $scope.groupObj.id + ".json", params, "get").then(function(data) {
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
            $scope.$emit("changeGroup", $scope.selectedNodeCopy);
        });
        //保存角色服务结束
    };
    /**
     * [initStatus description]初始化状态
     * @param {[]} [] [description] 
     * @return  [description] 
     */
    function initStatus() {
        $scope.cGtreeOptions = {
            nodeChildren: "CHILDREN",
            dirSelectable: true,
            allowDeselect: false,
            isLeaf: function(node) {
                return node.HASCHILDREN === "false";
            },
            isSelectable: function(node) {
                return node.HASRIGHT === "true";
            }

        };
        //设置默认展开目录开始
        //$scope.expandedChangeGroup = angular.copy($scope.expandedTest);
        $scope.treeData = angular.copy($scope.dataForTheTree);
        //设置默认展开目录结束
        initSelectNode();
        initExpandedNodes();
    }
    /**
     * [initSelectNode description]初始化状态
     * @param {[]} [] [description] 
     * @return  [description] 
     */
    function initSelectNode() {
        var flag = true;
        var selecteGroupId = $scope.selectedNode.GROUPID;
        if ($scope.treeData[0].GROUPID === selecteGroupId) {
            $scope.selectedNodeCopy = $scope.treeData[0];
        } else {
            checkNode($scope.treeData[0], function(node) {
                $scope.selectedNodeCopy = node;
            });
        }

        function checkNode(node, callback) {
            if (flag && angular.isDefined(node.CHILDREN) && node.CHILDREN.length > 0) {
                for (var i = 0; i < node.CHILDREN.length; i++) {
                    var cnode = node.CHILDREN[i];
                    if (cnode.GROUPID === selecteGroupId) {
                        flag = false;
                        callback(cnode);
                    } else {
                        checkNode(cnode, callback);
                    }
                }
            }
        }
    }
    /**
     * [initExpandedNodes description]初始化树展开状态
     * @param {[]} [] [description] 
     * @return  [description] 
     */
    function initExpandedNodes() {
        var expandedNodeCopy = [];
        for (var i = 0; i < $scope.expandedTest.length; i++) {
            var flag = false;
            checkNodes($scope.expandedTest[i], $scope.treeData, flag, function(node) {
                expandedNodeCopy.push(node);
            });
        }

        function checkNodes(node, nodeArray, flag, callback) {
            if (flag) return;
            for (var j = 0; j < nodeArray.length; j++) {
                if (node.GROUPID !== nodeArray[j].GROUPID && nodeArray[j].CHILDREN !== undefined) {
                    checkNodes(node, nodeArray[j].CHILDREN, flag, callback);
                } else if (node.GROUPID === nodeArray[j].GROUPID) {
                    flag = true;
                    callback(nodeArray[j]);
                    break;
                }
            }
        }
        $scope.expandedChangeGroup = expandedNodeCopy;
    }
}]);